import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import { ChevronLeft, ChevronRight } from '../ui/Icons';

function isModifierClick(event: React.MouseEvent) {
  const isMiddleClick = event.button === 1;

  return Boolean(
    isMiddleClick
    || event.altKey
    || event.ctrlKey
    || event.metaKey
    || event.shiftKey,
  );
}

export default function Pagination({
  pagination,
  paginationSettings,
}: componentTypes.PaginationProps) {
  const {
    pages,
    currentRefinement,
    isFirstPage,
    isLastPage,
    createURL,
    refine,
  } = pagination;

  const { translations } = paginationSettings;

  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;

  if (pages.length < 2) {
    return null;
  }

  return (
    <div className="flex flex-col items-center py-3">
      <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-sm">
        <a
          href={createURL(previousPageIndex)}
          aria-disabled={isFirstPage}
          onClick={(event) => {
            if (isModifierClick(event)) {
              return;
            }

            event.preventDefault();

            refine(previousPageIndex);
          }}
          className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 aria-disabled:pointer-events-none"
        >
          <span className="sr-only">{translations?.previousPageItemAriaLabel}</span>
          <ChevronLeft />
        </a>
        {pages.map((page) => (
          <a
            key={page}
            href={createURL(page)}
            onClick={(event) => {
              if (isModifierClick(event)) {
                return;
              }

              event.preventDefault();

              refine(page);
            }}
            className={`relative inline-flex items-center text-sm px-4 py-2 focus:z-20 no-underline ${page === currentRefinement ? 'z-10 bg-near-black text-white focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-near-black' : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0'}`}
            aria-current={page === currentRefinement ? 'page' : undefined}
          >
            {page + 1}
          </a>
        ))}
        <a
          href={createURL(nextPageIndex)}
          aria-disabled={isLastPage}
          onClick={(event) => {
            if (isModifierClick(event)) {
              return;
            }

            event.preventDefault();

            refine(nextPageIndex);
          }}
          className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 aria-disabled:pointer-events-none"
        >
          <span className="sr-only">{translations?.nextPageItemAriaLabel}</span>
          <ChevronRight />
        </a>
      </nav>
    </div>
  );
}
